import script from "./CompanyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&setup=true&lang=js"

import "./CompanyDetail.vue?vue&type=style&index=0&id=99a198c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99a198c8"]])

export default __exports__